<template>
  <v-dialog
    v-model="dialog"
    max-width="70vw"
    scrollable
    :retain-focus="false"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                label="ADSD Administrator "
                v-model="item.adsdAdministrator"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="Regional Center Administrator "
                v-model="item.regionalCenterAdmin"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="Regional Center Quality Assurance "
                v-model="item.regionalCenterQA"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="COPY to Regional Center Human Rights Committee "
                v-model="item.regionalCenterCHR"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Regional Center:"
                v-model="item.regionalCenter"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Provider"
                v-model="item.provider"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Date" v-model="item.date"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Time" v-model="item.time"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Age" v-model="item.age"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                :items="gender"
                label="Gender"
                v-model="item.gender"
              ></v-select>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                label="Exact Location"
                v-model="item.exactLocation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Reporting Staff"
                v-model="item.reportingStaff"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Staff Title"
                v-model="item.staffTitle"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Reporting Staff Signature"
                v-model="item.staffSignature"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class=" text-left ">
              <span class="subtitle-1 text-bold font-weight-bold"
                >In accordance with NRS 435.350 a person’s rights can be denied
                only for cause &nbsp;</span
              >(check all that apply)
            </v-col>
            <v-col cols="12" md="12">
              <v-radio-group
                v-model="item.isRightDenied"
                row
                @change="resetCheckbox"
              >
                <v-col cols="12" md="6" class="pa-0">
                  <v-radio
                    label="The person’s right has been denied/restricted"
                    :value="true"
                  ></v-radio>
                </v-col>
                <v-col cols="12" md="6" class="pa-0">
                  <v-radio
                    label="The intent is to deny/restrict the person’s right "
                    :value="false"
                  ></v-radio>
                </v-col>
              </v-radio-group>
            </v-col>
            <v-expand-transition>
              <v-col cols="12" md="12" v-if="item.isRightDenied" class="pa-0">
                <v-col cols="12" class=" text-left ">
                  <span class="subtitle-1 text-bold font-weight-bold"
                    >We have denied or intend to deny/restrict this person’s
                    right to: &nbsp;</span
                  >(check all that apply)
                </v-col>
                <v-col cols="12" md="12">
                  <v-checkbox
                    label="Be free from abuse, neglect, and exploitation. "
                    v-model="item.isFreeFromAbuse"
                  ></v-checkbox>
                  <v-checkbox
                    label="Refuse medication (person refuses or is unable to provide consent for medications) "
                    v-model="item.isRefuseMedication"
                  ></v-checkbox>
                  <v-checkbox
                    label="Refuse treatment (Tx) (other than medication) "
                    v-model="item.isRefuseTeatment"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class=" text-left ">
                  <span class="subtitle-1 text-bold font-weight-bold">
                    Informed consent to Tx (Informed consent for treatment not
                    obtained; lack of oversight review of restrictive Tx.)</span
                  >
                  <br />
                  <span
                    class="subtitle-1 text-bold font-weight-bold font-italic"
                  >
                    Note: Informed Consent includes guardian or advocate as
                    needed, full disclosure of risks and benefits.</span
                  >
                </v-col>
                <v-col cols="12" md="12">
                  <v-checkbox
                    label="Freedom of movement (Locked doors, access to own environment and community)"
                    v-model="item.isFreedomOfMovement"
                  ></v-checkbox>
                  <v-checkbox
                    label="Civil Rights (specify)"
                    v-model="item.isCivilRights"
                  ></v-checkbox>
                  <v-expand-transition>
                    <v-textarea
                      auto-grow
                      outlined
                      v-if="item.isCivilRights"
                      v-model="item.specifyCivilRights"
                    ></v-textarea>
                  </v-expand-transition>
                  <v-checkbox
                    label="Privacy (Personal privacy, confidentiality of records)  "
                    v-model="item.isPrivacy"
                  ></v-checkbox>
                  <v-checkbox
                    label="Freedom of association (Have visitors each day, contact with people of own choosing) "
                    v-model="item.isFreedomOfAssociation"
                  ></v-checkbox>
                  <v-checkbox
                    label="Make/receive confidential phone calls and mail; Access to communication assistance  "
                    v-model="item.isMakeRecieveConfidential"
                  ></v-checkbox>
                  <v-checkbox
                    label="Keep personal possessions, including own clothing "
                    v-model="item.isKeepPersonal"
                  ></v-checkbox>
                  <v-checkbox
                    label="Right to treatment (Medical/Dental or as specified in the ISP)"
                    v-model="item.isRightToTreatment"
                  ></v-checkbox>
                  <v-checkbox
                    label="Free access to own spending money (specify)"
                    v-model="item.isFreeAcess"
                  ></v-checkbox>
                  <v-expand-transition>
                    <v-textarea
                      auto-grow
                      outlined
                      v-model="item.freeAccessSpecify"
                      v-if="item.isFreeAcess"
                    ></v-textarea>
                  </v-expand-transition>
                  <v-checkbox
                    label="Other (specify)"
                    v-model="item.isOther"
                  ></v-checkbox>
                  <v-expand-transition>
                    <v-textarea
                      auto-grow
                      outlined
                      v-model="item.otherSpecify"
                      v-if="item.isOther"
                    ></v-textarea>
                  </v-expand-transition>
                </v-col>
              </v-col>
            </v-expand-transition>
            <v-col cols="12" md="12">
              <v-textarea
                auto-grow
                outlined
                label="Describe the situation that resulted in the denial or intent to deny rights"
                v-model="item.describeSituation"
              ></v-textarea>
              <v-textarea
                auto-grow
                outlined
                label="Describe specific information about the actual denial or intent to deny rights."
                v-model="item.describeSpecificInformation"
              ></v-textarea>
              <v-textarea
                auto-grow
                outlined
                label="Describe actions that were taken to avoid or prevent the need for this denial or intent to deny rights"
                v-model="item.describeActions"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Who was Contacted/Notified"
                v-model="item.contactedNotified"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Witness to denial (full name)"
                v-model="item.witnessToDenial"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Witness Title"
                v-model="item.witnessTitle"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea
                auto-grow
                outlined
                label="Provider or RC review and actions taken: "
                v-model="item.ProviderActionTaken"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Person receiving services (Name):  "
                v-model="item.personRecievingService"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Agency Case Number"
                v-model="item.caseNo"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          Close
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="newItem ? onAddItem() : onUpdateItem(item._id)"
        >
          {{ newItem ? "Save" : "Update" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import { mapActions } from "vuex";

export default {
  data() {
    return {
      gender: ["Male", "Female"],
      // clientID: localStorage.getItem("clientId"),
      newItem: true,
      item: {
        caseNo: "",
        adsdAdministrator: "",
        regionalCenterAdmin: "",
        regionalCenterQA: "",
        regionalCenterCHR: "",
        adminDate: "",
        regionalCenter: "",
        provider: "",
        date: "",
        time: "",
        age: "",
        gender: "",
        exactLocation: "",
        reportingStaff: "",
        staffTitle: "",
        staffSignature: "",
        isRightDenied: null,
        isIntentDenied: null,
        isFreeFromAbuse: false,
        isRefuseMedication: false,
        isRefuseTeatment: false,
        isFreedomOfMovement: false,
        isCivilRights: false,
        specifyCivilRights: "",
        isPrivacy: false,
        isFreedomOfAssociation: false,
        isMakeRecieveConfidential: false,
        isKeepPersonal: false,
        isRightToTreatment: false,
        isFreeAcess: false,
        freeAccessSpecify: "",
        isOther: false,
        otherSpecify: "",
        describeSituation: "",
        describeSpecificInformation: "",
        describeActions: "",
        contactedNotified: "",
        witnessToDenial: "",
        witnessTitle: "",
        ProviderActionTaken: "",
        personRecievingService: "",
      },
      defaultItem: {
        caseNo: "",
        adsdAdministrator: "",
        regionalCenterAdmin: "",
        regionalCenterQA: "",
        regionalCenterCHR: "",
        adminDate: "",
        regionalCenter: "",
        provider: "",
        date: "",
        time: "",
        age: "",
        gender: "",
        exactLocation: "",
        reportingStaff: "",
        staffTitle: "",
        staffSignature: "",
        isRightDenied: null,
        isIntentDenied: null,
        isFreeFromAbuse: false,
        isRefuseMedication: false,
        isRefuseTeatment: false,
        isFreedomOfMovement: false,
        isCivilRights: false,
        specifyCivilRights: "",
        isPrivacy: false,
        isFreedomOfAssociation: false,
        isMakeRecieveConfidential: false,
        isKeepPersonal: false,
        isRightToTreatment: false,
        isFreeAcess: false,
        freeAccessSpecify: "",
        isOther: false,
        otherSpecify: "",
        describeSituation: "",
        describeSpecificInformation: "",
        describeActions: "",
        contactedNotified: "",
        witnessToDenial: "",
        witnessTitle: "",
        ProviderActionTaken: "",
        personRecievingService: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.newItem ? "New DOR" : "Edit DOR";
    },
    dialog: {
      get() {
        return this.$store.state.dor.dialog;
      },
      set(val) {
        this.$store.commit("dor/SET_DIALOG", val);
      },
    },
    clientID(){
      return this.$store.state.clients.client._id
    },
  },
  methods: {
    ...mapActions("dor", ["addDOR", "updateDOR"]),

    onViewItem(item) {
      this.newItem = false;
      this.item = Object.assign({}, item);
      this.dialog = true;
    },
    async onAddItem() {
      try {
        this.newItem = true;
        const response = await this.addDOR({
          ...this.item,
          clientID: this.clientID,
          isIntentDenied:
            this.item.isRightDenied === null
              ? this.item.isRightDenied
              : !this.item.isRightDenied,
        });

        if (response.success) {
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async onUpdateItem(id) {
      try {
        const response = await this.updateDOR({
          data: this.item,
          id,
        });

        if (response.success) {
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },

    resetCheckbox() {
      if (!this.item.isRightDenied) {
        this.item.isFreeFromAbuse = false;
        this.item.isRefuseMedication = false;
        this.item.isRefuseTeatment = false;
        this.item.isFreedomOfMovement = false;
        this.item.isCivilRights = false;
        this.item.specifyCivilRights = "";
        this.item.isPrivacy = false;
        this.item.isFreedomOfAssociation = false;
        this.item.isMakeRecieveConfidential = false;
        this.item.isKeepPersonal = false;
        this.item.isRightToTreatment = false;
        this.item.isFreeAcess = false;
        this.item.freeAccessSpecify = "";
        this.item.isOther = false;
        this.item.otherSpecify = "";
      }
    },

    close() {
      this.dialog = false;
      this.newItem = true;
      this.$nextTick(() => {
        this.item = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>
